module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-12-900-normal.20fb735.woff2";